module.exports = __webpack_public_path__ + "img/Tiktok.8b127fb2.svg";